import { isCustomAuthEnabled } from 'modules/auth/config/authConfig';

/**
 * Intercept Cognito SAML callback when using custom auth provider (e.g. AXA with Myriam).
 * When Cognito redirects back with ?code= in the main URL (before the hash),
 * HashRouter can't see it. Redirect to #/callback so CognitoSamlCallback can process it.
 *
 * Only runs when REACT_APP_AUTH_PROVIDER=custom to avoid breaking Auth0 flows
 * (Auth0 needs code+state in the query string; this redirect would drop state).
 */
export const initSamlCallbackRedirect = () => {
  if (!isCustomAuthEnabled()) return;

  // Check code in query string (Cognito redirect: /?code=xxx)
  let params = new URLSearchParams(window.location.search);
  let code = params.get('code');

  // Also check hash (e.g. #/login?code=xxx when redirect_uri includes hash path)
  if (!code && window.location.hash.includes('?')) {
    const hashQuery = window.location.hash.split('?')[1] || '';
    params = new URLSearchParams(hashQuery);
    code = params.get('code');
  }

  const hasCode = !!code;
  const hasError = !!params.get('error');
  const hasState = !!params.get('state');
  const currentHash = window.location.hash || '(empty)';

  console.log('[SAML] initSamlCallbackRedirect:', {
    hasCode,
    hasError,
    hasErrorValue: params.get('error') || null,
    hasState,
    fullUrl: `${window.location.origin}${window.location.pathname}${window.location.search}`,
    currentHash,
    willRedirectToCallback: hasCode && !window.location.hash.includes('/callback'),
  });

  if (code && !window.location.hash.includes('/callback')) {
    const { origin, pathname } = window.location;
    const encodedCode = encodeURIComponent(code);

    const callbackUrl = `${origin}${pathname}#/callback?code=${encodedCode}`;

    console.log('[SAML] Redirecting to callback URL (code in hash):', {
      callbackUrl: callbackUrl.replace(/code=[^&]+/, 'code=***'),
      codeLength: code.length,
    });

    window.location.replace(callbackUrl);
  }
};
